import { Bank, Cash, CreditCard, Flow, Organization, PaymentMethodsType, Table, User } from ".";
import { Branch } from "./branch";
import { OrderItem } from "./items";
import { OrderReview } from "./surveys";
import { AnonymousUser, DeliveryLocation } from "./user";

export enum OrderStatus {
  DRAFT = "draft",
  REJECTED = "rejected",
  CANCELLED = "cancelled",
  REVIEWING = "reviewing",
  PENDING_PAYMENT = "pending-payment",
  PREPARING = "preparing",
  SENDING = "sending",
  DELIVERED = "delivered",
  WAITING = "waiting",
  PAID = "paid", //TODO: remove paid  from status
  COMPLETED = "completed",
  ARCHIVED = "archived",
}

export enum DeliveryStatus {
  APPROVED = "approved",
  DECLINED = "declined",
  REQUESTED = "requested",
  DELIVERED = "delivered",
}

export interface EmptyOrder {
  // TODO: Try to use the OrderDraft convention
  items: OrderItem[];
  subtotal: number;
  taxes: number;
  areTipsIncluded: boolean;
  tipPercentage: number;
  total: number;
}

export interface Order extends Partial<EmptyOrder> {
  id: string;
  status: OrderStatus;
  organizationId: Organization["id"];
  tableId: Table["id"];
  paidBy?: User["uid"];
  paidAt?: number;
  number: number;
  items: OrderItem[];
  paymentDetails: {
    method: PaymentMethodsType;
    value: null | CreditCard | Bank | Cash;
    status?: "pending" | "paid" | "canceled";
    paymentId?: string;
    stripeSessionId?: string;
    paidAt?: number;
  } | null;
  deliveryLocation?: DeliveryLocation;
  client: AnonymousUser | User;
  flow?: Flow | null;
  source?: string;
  branch?: Pick<Branch, "id" | "title" | "location" | "whatsapp"> | null;
  scheduleTime?: Date | number | null;
  serviceFee?: number;
  deliveryFee?: number;
  rejectedReason?: "timeout" | string;
  branchId?: string;
  orderReview?: OrderReview | null;

  // Timestamps
  createdAt: number; // draft
  orderedAt?: number; // reviewing
  approvedAt?: number; // preparing
  rejectedAt?: number; // rejected
  sendingAt?: number; // sending
  completedAt?: number; // completed
  expiresAt?: number;
  timeoutTaskName?: string;
  lastUpdatedAt?: number;

  // Others
  archivedAt?: number;
  lastUpdatedBy?: string;
  rejectedBy?: User["uid"] | AnonymousUser;
  completedBy?: User["uid"] | AnonymousUser;
  createdBy?: User["uid"] | AnonymousUser;
}

export interface ArchiveOrder extends Partial<Order> {
  id: string;
  archivedAt: number;
  archivedBy: User["uid"] | AnonymousUser;
}

export interface CompletedOrder extends Partial<Order> {
  id: string;
  completedAt: number;
  completedBy: User["uid"] | AnonymousUser;
}
